import 'react-toastify/dist/ReactToastify.css';
import './app.scss';
import 'app/config/dayjs';

import React, { useEffect, useState } from 'react';
import { Card } from 'reactstrap';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getSession } from 'app/shared/reducers/authentication';
import { getProfile } from 'app/shared/reducers/application-profile';
import Header from 'app/shared/layout/header/header';
import Footer from 'app/shared/layout/footer/footer';
import { hasAnyAuthority } from 'app/shared/auth/private-route';
import ErrorBoundary from 'app/shared/error/error-boundary';
import { AUTHORITIES } from 'app/config/constants';
import AppRoutes from 'app/routes';
import { AuthMenu } from 'app/shared/layout/authmenu/auth-menu';
import { AnnouncementPopup } from 'app/shared/components/announcement-popup';
import { LanguageProvider } from 'app/shared/i18n';

const baseHref = document.querySelector('base').getAttribute('href').replace(/\/$/, '');

export const App = () => {
  const dispatch = useAppDispatch();
  const [showDropdown, setShowDropdown] = useState(false);
  const [showDropdownAuth, setShowDropdownAuth] = useState(false);

  useEffect(() => {
    dispatch(getSession());
    dispatch(getProfile());
  }, []);

  const isAuthenticated = useAppSelector(state => state.authentication.isAuthenticated);
  const isAdmin = useAppSelector(state => hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.ADMIN]));
  const ribbonEnv = useAppSelector(state => state.applicationProfile.ribbonEnv);
  const isInProduction = useAppSelector(state => state.applicationProfile.inProduction);
  const isOpenAPIEnabled = useAppSelector(state => state.applicationProfile.isOpenAPIEnabled);
  const username = useAppSelector(state => state.authentication.account.login);
  const balance = useAppSelector(state => state.authentication.account.wallet);
  const rank = useAppSelector(state => state.authentication.account.rank);

  return (
    <LanguageProvider>
      <BrowserRouter basename={baseHref}>
        <div className={`app-container ${showDropdown ? 'dropshow--main_catalog' : ''} ${showDropdownAuth ? 'dropshow--auth' : ''}`}>
          <ToastContainer position="top-left" className="toastify-container" toastClassName="toastify-toast" />
          <ErrorBoundary>
            <Header
              isAuthenticated={isAuthenticated}
              isAdmin={isAdmin}
              ribbonEnv={ribbonEnv}
              isInProduction={isInProduction}
              isOpenAPIEnabled={isOpenAPIEnabled}
              username={username}
              balance={balance}
              rank={rank}
              setShowDropdown={setShowDropdown}
              setShowDropdownAuth={setShowDropdownAuth}
            />
            {isAuthenticated && <AuthMenu isAdmin={isAdmin} />}
          </ErrorBoundary>
          <div className={`container-fluid main-body ${isAuthenticated && 'auth'}`} id="app-view-container">
            {/* <Card className="jh-card">*/}
            <ErrorBoundary>
              <AppRoutes />
            </ErrorBoundary>
            {/* </Card>*/}
            <Footer />
          </div>
          <div className={`layer__overlay`} />
          {!isAdmin && <AnnouncementPopup />}
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
};

export default App;
